"use strict";
exports.__esModule = true;
exports.FooterCardType = exports.SocialLinkTypes = exports.FooterLinkTypes = void 0;
var FooterLinkTypes;
(function (FooterLinkTypes) {
    FooterLinkTypes["FOOTER_LINK"] = "footerLink";
    FooterLinkTypes["RGPD_LINK"] = "rgpdLink";
})(FooterLinkTypes = exports.FooterLinkTypes || (exports.FooterLinkTypes = {}));
var SocialLinkTypes;
(function (SocialLinkTypes) {
    SocialLinkTypes["FACEBOOK"] = "Facebook";
    SocialLinkTypes["INSTAGRAM"] = "Instagram";
    SocialLinkTypes["LINKEDIN"] = "LinkedIn";
    SocialLinkTypes["TWITTER"] = "Twitter";
    SocialLinkTypes["YOUTUBE"] = "Youtube";
})(SocialLinkTypes = exports.SocialLinkTypes || (exports.SocialLinkTypes = {}));
exports.FooterCardType = {
    SIMPLE: 'simpleCardContainer',
    MULTIPLE: 'multipleCardsContainer',
    ICON: 'iconCardsContainer'
};
//# sourceMappingURL=footer.js.map